import { render, staticRenderFns } from "./xyfPrice.vue?vue&type=template&id=28e74dbf&scoped=true"
import script from "./xyfPrice.vue?vue&type=script&lang=js"
export * from "./xyfPrice.vue?vue&type=script&lang=js"
import style0 from "./xyfPrice.vue?vue&type=style&index=0&id=28e74dbf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e74dbf",
  null
  
)

export default component.exports